// extracted by mini-css-extract-plugin
export var container = "_fx-0";
export var dotAnimation = "_fx-2";
export var dotsLoading = "_fx-1";